import React, { useState, useEffect, useRef } from "react";
import "./Home.css";
import img1 from "../assets/1.png";
import img2 from "../assets/2.jpg";
import img3 from "../assets/3.jpg";
import img4 from "../assets/4.jpg";
import img5 from "../assets/5.jpg";
import img6 from "../assets/6.jpeg";
// import img7 from "../assets/7.jpeg";
// import img8 from "../assets/8.jpeg";
import img10 from "../assets/10.jpeg";
import img11 from "../assets/10.jpeg";
import img12 from "../assets/11.jpeg";
import { db } from "../firebase";
import { ref, runTransaction, onValue } from "firebase/database";


const sliderImages = [img1, img2, img3, img4, img5, img6, img10, img11, img12];

const newsList = [
  // "Congratulations to Dr. Chitra Jaiswal for successfully defending her Ph.D. thesis",
  // "Congratulations to Kodieswaran on his first publication in ACS Applied Materials & Interfaces",
  // "Heartiest Congratulations to Prof. Biman B. Mandal for being elected as a Fellow of the Society for Biomaterials and Artificial Organs, India (SBAOI)",
  // "Congratulations to Souradeep for his research publication in Biomaterials",
  // "Our lab is now recognised as \"CENTRE FOR ADVANCED RESEARCH\" (CAR) by ICMR with major funding support",
  // "Prof. Mandal awarded SWARNAJAYANTI Fellowship 2020 in Life Sciences by DST",
  // "Prof. Mandal awarded S. Ramachandran NATIONAL BIOSCIENCE AWARD for Career Development 2021 by DBT",
  // 'Prof. Mandal listed as "World Top 2% Scientist" prepared by Stanford University USA 2020',
  // "Prof. Mandal awarded B.M. BIRLA SCIENCE PRIZE 2018 in Biology",
  // "Congratulations to Shreya for publication in AFM, Small and ACS Nano",
  // "Congratulations to Yogendra for publication in Advanced Healthcare Materials",
  // "Our group is recognised as a DBT-UNIT OF EXCELLENCE with a major funding support"
  "Congratulations to Kodieswaran for his research publication in Biomaterials",
  "Heartiest Congratulations to Prof. Biman B Mandal for being elected as a Fellow of the National Academy of Sciences, India (NASI)",
  "Congratulations to Rajat Dadheech on receiving ACS Best Oral Presentation Award in TRANSMATTER 2026 held at IIT Kharagpur",
  "Congratulations to Victoria J on receiving ACS Best Poster Presentation Award in TRANSMATTER 2026 held at IIT Kharagpur",
  "Congratulations to Chevella Maheshwari on her first publication in 'Small' Journal",
  "Congratulations Dr. Souradeep for successfully defending his Ph.D. thesis",
  "Congratulations to Rajat on his first publication in ACS Biomaterials Science & Engineering",
  " Congratulations Dr. Chitra for successfully defending her Ph.D. thesis",
  "Congratulations to Kodieswaran on his first publication in ACS Applied Materials & Interfaces",
  "Heartiest Congratulations to Prof. Biman B. Mandal for being elected as a Fellow of the Society for Biomaterials and Artificial Organs, India (SBAOI)",
  "Congratulations to Souradeep for his research publication in Biomaterials",
  "Our lab is now recognised as “CENTRE FOR ADVANCED RESEARCH” (CAR) by ICMR with major funding support.",
];

const researchInterests = [
  {
    number: '1',
    title: 'Biomaterials & Tissue Engineering',
    icon: '🧬'
  },
  {
    number: '2',
    title: '3D Bioprinting of Human Tissue and Organs',
    icon: '🖨️'
  },
  {
    number: '3',
    title: 'Human Stem Cells Based Regeneration',
    icon: '🔬'
  },
  {
    number: '4',
    title: 'Targeted Drug Delivery Systems',
    icon: '💊'
  },
  {
    number: '5',
    title: '3D Disease Models for High Throughput Drug Screening',
    icon: '🧫'
  }
];


const Home = () => {
  // Image slider
  const [imgIdx, setImgIdx] = useState(0);

  useEffect(() => {
    const slider = setInterval(() => {
      setImgIdx((prev) => (prev + 1) % sliderImages.length);
    }, 3000);
    return () => clearInterval(slider);
  }, []);

  // News ticker with hover pause
  const [paused, setPaused] = useState(false);
  const tickerRef = useRef(null);

  // Visitor counter - inside Home component
  const [visitorCount, setVisitorCount] = useState(0);
  useEffect(() => {
    const countRef = ref(db, "visitorCount");

    const visited = sessionStorage.getItem("visited");
    if (!visited) {
      sessionStorage.setItem("visited", "true");
      runTransaction(countRef, (current) => (current || 0) + 1);
    }

    const unsubscribe = onValue(countRef, (snapshot) => {
      setVisitorCount(snapshot.val() || 0);
    });

    return () => unsubscribe();
  }, []);

  return (
    <div className="_1home-wrapper">
      <section className="_1homepage-main">
        {/* Left: Image Slider */}
        <div className="_1slider-outer">
          <div className="_1slider-window">
            <img
              src={sliderImages[imgIdx]}
              alt={`highlight group ${imgIdx + 1}`}
              className="_1slider-img"
            />
          </div>
        </div>
        
        {/* Right: NEWS & UPDATES */}
      <div className="_1news-outer">
        <div className="_1news-title">NEWS & UPDATES</div>
        <div
          className="_1news-partition"
          onMouseEnter={() => setPaused(true)}
          onMouseLeave={() => setPaused(false)}
        >
          <div className={`_1news-ticker ${paused ? '_1news-ticker-paused' : ''}`}>
            <div className="_1news-ticker-list">
              {[...newsList, ...newsList].map((item, idx) => (
                <div className="_1news-ticker-item" key={idx}>
                  {item}
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
      </section>

            {/* Research Interests Section */}
      <section className="_1research-interests-section">
        <div className="_1research-interests-container">
          <h2 className="_1research-interests-title">Research Interests</h2>
          <div className="_1research-interests-underline"></div>
          
          <div className="_1research-interest-item" onClick={() => window.location.href = '/biman.mandal/#/research?category=organonchip'}>
            <div className="_1research-number-box">
              <span className="_1research-number">1</span>
            </div>
            <div className="_1research-icon">🧬</div>
            <div className="_1research-content">
              <span className="_1research-text">
                <a href="/biman.mandal/#/research?category=organonchip" className="_1research-link">
                  Organ-on-Chip Technologies
                </a>
              </span>
            </div>
          </div>

          <div className="_1research-interest-item" onClick={() => window.location.href = '/biman.mandal/#/research?category=bioprinting'}>
            <div className="_1research-number-box">
              <span className="_1research-number">2</span>
            </div>
            <div className="_1research-icon">🖨️</div>
            <div className="_1research-content">
              <span className="_1research-text">
                <a href="/biman.mandal/#/research?category=bioprinting" className="_1research-link">
                  3D Bioprinting
                </a>
              </span>
            </div>
          </div>

          <div className="_1research-interest-item" onClick={() => window.location.href = '/biman.mandal/#/research?category=drug'}>
            <div className="_1research-number-box">
              <span className="_1research-number">3</span>
            </div>
            <div className="_1research-icon">💊</div>
            <div className="_1research-content">
              <span className="_1research-text">
                <a href="/biman.mandal/#/research?category=drug" className="_1research-link">
                  Targeted Drug Delivery Systems
                </a>
              </span>
            </div>
          </div>

          <div className="_1research-interest-item" onClick={() => window.location.href = '/biman.mandal/#/research?category=tissue'}>
            <div className="_1research-number-box">
              <span className="_1research-number">4</span>
            </div>
            <div className="_1research-icon">🔬</div>
            <div className="_1research-content">
              <span className="_1research-text">
                <a href="/biman.mandal/#/research?category=tissue" className="_1research-link">
                  Tissue Engineering
                </a>
              </span>
            </div>
          </div>
        </div>
      </section>
      {/* Visitor Counter
      <div className="_1visitor-counter-section">
        <div className="_1visitor-counter">
          <span className="_1visitor-icon">👁️</span>
          <span className="_1visitor-label">Visitors</span>
          <div className="_1visitor-digits">
            {(visitorCount ?? 0)
              .toString()
              .padStart(6, "0")
              .split("")
              .map((digit, i) => (
            <span key={i} className="_1visitor-digit">
              {digit}
            </span>
            ))}
          </div>
        </div>
      </div> */}
    </div>
  );
};

export default Home;